export const accountPageConstants = {
  UPDATING_TABLE: "UPDATING_TABLE",
  UPDATE_TABLE_COMPLETED: "UPDATE_TABLE_COMPLETED",
  LOADING_TABLE: "LOADING_TABLE",
  SET_ELIGIBLE: "SET_ELIGIBLE"
};
